import React from "react";

function diffDays(a, b) {
 return Math.round((b - a) / 86400000);
}

/**
 * TenancyProgress. a slim progress bar showing how far through the lease the tenant is.
 * `size` controls the variant: 'compact' (for dashboard cards) | 'large' (for case header)
 */
export default function TenancyProgress({ leaseStart, leaseEnd, size = "compact" }) {
 if (!leaseStart || !leaseEnd) return null;
 const start = new Date(leaseStart);
 const end = new Date(leaseEnd);
 const today = new Date();

 const totalDays = diffDays(start, end);
 const elapsed = diffDays(start, today);
 const remaining = diffDays(today, end);
 if (totalDays <= 0) return null;

 const pct = Math.max(0, Math.min(100, Math.round((elapsed / totalDays) * 100)));
 const beforeStart = today < start;
 const afterEnd = today > end;

 const label = beforeStart
 ? `Starts in ${diffDays(today, start)} days`
 : afterEnd
 ? `Ended ${diffDays(end, today)} days ago`
 : `Day ${elapsed} of ${totalDays} · ${remaining} days remaining`;

 const fillClr = afterEnd ? "#B35D4C" : beforeStart ? "#9CA3AF" : "#1B6C62";

 if (size === "large") {
 return (
 <div className="mt-5 pt-5 border-t border-[#E5E4DE]" data-testid="tenancy-progress">
 <div className="flex justify-between items-baseline mb-2">
 <span className="label-mono">Tenancy progress</span>
 <span className="font-mono text-sm text-[#0D2B52]">{pct}%</span>
 </div>
 <div className="h-2 bg-[#E5E4DE] overflow-hidden rounded-sm">
 <div className="h-full transition-all duration-700" style={{ width: `${pct}%`, background: fillClr }} />
 </div>
 <div className="flex justify-between mt-2 text-xs text-[#6B7280]">
 <span className="font-mono">{leaseStart}</span>
 <span>{label}</span>
 <span className="font-mono">{leaseEnd}</span>
 </div>
 </div>
 );
 }

 // compact (dashboard card)
 return (
 <div className="mt-3" data-testid="tenancy-progress-compact">
 <div className="h-1 bg-[#E5E4DE] overflow-hidden">
 <div className="h-full" style={{ width: `${pct}%`, background: fillClr }} />
 </div>
 <div className="flex justify-between mt-1.5 text-[10px] text-[#6B7280] font-mono uppercase tracking-wider">
 <span>{pct}% in</span>
 <span>{beforeStart ? `starts ${diffDays(today, start)}d` : afterEnd ? `ended ${diffDays(end, today)}d ago` : `${remaining}d left`}</span>
 </div>
 </div>
 );
}
